var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#516670",
    d: "M2 0h16c1.105 0 2 .895 2 2v13.242c0 1.105-.895 2-2 2h-2.647c-.786 0-1.5.46-1.823 1.176-.477 1.055-.968 1.582-1.473 1.582-.514 0-1.035-.544-1.564-1.632-.335-.689-1.034-1.126-1.8-1.126H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    y: 2,
    stroke: "#FFF",
    strokeWidth: 1.25,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FFF",
    stroke: "#516670"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notification-info.aff9fbf982cbd5d84be5e8463844f84d.svg";
export { ForwardRef as ReactComponent };